import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import CustomSelect from "../../../component/CustomSelect";
import CustomImageUpload from "../../../component/CustomImageUpload";
import DynamicCKEditor from "../../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import { Link } from "react-router-dom";

const addFeatureEndpoint = ApiEndpoints.featureService.featureServiceCreate;
const FeatureCategoryListEndpoint = ApiEndpoints.featureCategory.featureList;
const FeatureList = ApiEndpoints.featureService.featureServiceList;

const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function AddFeature() {
  const navigate = useNavigate();
  const [featureCategory, setFeatureCategory] = useState([]);
    const [featureData, setfeatureData] = useState([]);

  const [previews, setPreviews] = useState({ section2_box1_icon: null, section2_box2_icon: null, section2_box3_icon: null, section1_thumbnail:null });
  const [postData, setPostData] = useState({
    feature_category_id: "",   section1_title: "", section1_brief: "", section1_thumbnail: "null", section2_blue_heading: "", section2_title: "", section2_description: "", section2_box1_icon: null, section2_box1_description: "", section2_box2_icon: null, section2_box2_description: "", section2_box3_icon: null, section2_box3_description: "", section3_video_url: "", section7_heading: "", section7_description: "",
    section7_inner_features: [
      { title: "", description: "", icon: null },],
    faqs: [
      { question: "", answer: "", },
    ],
  });




  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", FeatureCategoryListEndpoint);
        console.log("API RESPONSE:", response);
        setFeatureCategory(response?.feature_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setFeatureCategory([]);
      }
    };


    const fetchFeature = async () => {
      try {
        const response = await ApiRequest("GET", FeatureList);
        console.log("API RESPONSE:", response);
        setfeatureData(response?.features || []);
      } catch (error) {
        console.error("Failed to fetch features:", error);
        setfeatureData([]);
      }
    };

  fetchFeature();
  fetchCategories();
  }, []);


const filteredCategories = featureCategory.filter(category =>
  !featureData.some(data => data.feature_category_id === category._id)
);
    

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    const finalValue = files ? files[0] : value;
    setPostData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
    if (files) {
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(files[0]),
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };




  // ================= SECTION 3 =================
  const handleFeatureChange = (index, field, value) => {
    const updated = [...postData.section7_inner_features];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section7_inner_features: updated,
    }));
  };

  const handleAddMoreFeature = (e) => {
    e.preventDefault();
    if (postData.section7_inner_features.length >= 10) {
      toast.warning("Max 10 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section7_inner_features: [
        ...prev.section7_inner_features,
        { title: "", description: "", icon: null, },
      ],
    }));
  };

  const handleRemoveFeature = (index) => {
    if (postData.section7_inner_features.length === 1) return;
    const updated = postData.section7_inner_features.filter((_, i) => i !== index);
    setPostData((prev) => ({
      ...prev,
      section7_inner_features: updated,
    }));
  };



  // =================  Faq =================
  const handleFaqChange = (index, field, value) => {
    const updated = [...postData.faqs];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      faqs: updated,
    }));
  };

  const handleAddMoreFaq = (e) => {
    e.preventDefault();

    if (postData.faqs.length >= 10) {
      toast.warning("Max 10 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      faqs: [
        ...prev.faqs,
        { question: "", answer: "" },
      ],
    }));
  };

  const handleRemoveFaq = (index) => {
    if (postData.faqs.length === 1) return;
    const updated = postData.faqs.filter((_, i) => i !== index);
    setPostData((prev) => ({
      ...prev,
      faqs: updated,
    }));
  };


  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    const ignoreFields = ["_id", "__v", "createdAt", "updatedAt"];

    // ================= VALIDATION =================
    for (const [key, value] of Object.entries(postData)) {
      if (ignoreFields.includes(key)) continue;
      if (Array.isArray(value)) continue;
      if (!value) {
        toast.error(`${key} is required`);
        return;
      }
    }

    // section3 validation
    for (let i = 0; i < postData.section7_inner_features.length; i++) {
      const item = postData.section7_inner_features[i];
      if (!item.title || !item.description || !item.icon) {
        toast.error(`Feature item ${i + 1} incomplete`);
        return;
      }
    }

    // section5 validation
    for (let i = 0; i < postData.faqs.length; i++) {
      const item = postData.faqs[i];
      if (!item.question || !item.answer) {
        toast.error(`Section5 item ${i + 1} incomplete`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (ignoreFields.includes(key)) return;
      if (Array.isArray(value)) {
        value.forEach((item, i) => {
          if (item.icon) {
            formData.append(`${key}[${i}][icon]`, item.icon);
          }
        });
        const cleanArray = value.map(item => {
          const { icon, ...rest } = item;
          return rest;
        });
        formData.append(key, JSON.stringify(cleanArray));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", addFeatureEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data", },
      });
      toast.success(response.message);
      navigate("/feature-service");
    } catch (error) {
      toast.error("Form data is too large. Please add less fields than add remaining in edit.");
      console.error("Error submitting form:", error);
    }
  };


  const pagename = {
    name: 'Feature Deatils',
    user: 'Admin',
    innerpage: 'Feature Deatils'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
                <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="feature_category_id" options={filteredCategories} placeholder="Select Category" />
                </div>
              </div>
             
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Brief<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_brief" type="text" className="form-control" placeholder="Enter Brief" />

                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail (804 × 780)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section1_thumbnail"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section1_thumbnail} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="col-lg-12">
              <h3 className="heading-text" > Section 2 </h3>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label> Blue Heading <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_blue_heading" type="text" className="form-control" placeholder="Enter Heading" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Title <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_description} onChange={(event, editor) => handleEditorChange("section2_description", editor?.getData())} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Icon (60*60) <small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_box1_icon"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_box1_icon} />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_box1_description} onChange={(event, editor) => handleEditorChange("section2_box1_description", editor?.getData())} />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Icon (60*60) <small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_box2_icon"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_box2_icon} />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_box2_description} onChange={(event, editor) => handleEditorChange("section2_box2_description", editor?.getData())} />
                </div>

              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Icon (60*60) <small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_box3_icon"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_box3_icon}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_box3_description} onChange={(event, editor) => handleEditorChange("section2_box3_description", editor?.getData())} />
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Video Url  <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_video_url" type="text" className="form-control" placeholder="Enter Video Url" />
                </div>
              </div>
            </div>

          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" >  Section 7 </h3>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Heading  <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_heading" type="text" className="form-control" placeholder="Enter Heading" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Description <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section7_description} onChange={(event, editor) => handleEditorChange("section7_description", editor?.getData())} />
                </div>
              </div>

              {postData.section7_inner_features.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Title <small>*</small></label>
                      </div>
                      <input className="form-control" placeholder="title" value={item.title}
                        onChange={(e) => handleFeatureChange(index, "title", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Description <small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                        handleFeatureChange(index, "description", editor.getData())} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Icon (90*90)<small>*</small></label>
                      </div>
                      <CustomImageUpload
                        acceptedFormats={[".webp"]}
                        onImageChange={(e) => handleFeatureChange(index, "icon", e.target.files[0])}
                        imagePreview={item.icon ? URL.createObjectURL(item.icon) : null} />
                    </div>
                  </div>
                  {postData.section7_inner_features.length > 1 && (
                    <button className="remove-btn" onClick={() => handleRemoveFeature(index)}>Remove </button>
                  )}
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreFeature}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" > Faq </h3>
              </div>
              {postData.faqs.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> question <small>*</small></label>
                      </div>
                      <input placeholder="question" className="form-control" value={item.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> answer <small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.answer} onChange={(e, editor) =>
                        handleFaqChange(index, "answer", editor.getData())} />
                    </div>
                    {postData.faqs.length > 1 && (
                      <button className="remove-btn" onClick={() => handleRemoveFaq(index)}>    Remove   </button>
                    )}
                  </div>
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreFaq}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">Publish <span></span></button>
      </div>
    </>
  );
}

